import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Logo from '~/images/apps/logo.jpg';
import { Popover, Tooltip, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { CollapseOpenIcon, MenuIcon } from '@import/icons';
import { DrawerCollapseChildrenContentStyled, DrawerCollapseChildrenStyled, DrawerCollapseStyled, DrawerContentStyled, DrawerStyled, DrawerSwitchButtonStyled, LogoWrapperStyled, MenuItemListSideBar, PopupDrawerContentStyled } from '@libs/@core/components/drawer/BaseDrawerDesktop.styled';
var iconWidth = 57;
var PopupDrawer = function (_a) {
    var open = _a.open, title = _a.title, anchorEl = _a.anchorEl, listItems = _a.listItems, onClose = _a.onClose;
    return (_jsx(Popover, { open: open, anchorEl: anchorEl, onClose: onClose, anchorOrigin: {
            vertical: 'center',
            horizontal: 'right'
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
        }, children: _jsxs(PopupDrawerContentStyled, { children: [_jsx(Typography, { variant: 'h5', children: title }), listItems.map(function (item, index) { return (_jsx("div", { className: 'item_popup', children: _jsx(Typography, { flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', children: item.text }) }, "".concat(item.text, "_").concat(index))); })] }) }));
};
var BaseDrawerChild = function (_a) {
    var _b;
    var item = _a.item, isChild = _a.isChild, isOpenDrawer = _a.isOpenDrawer;
    var navigate = useNavigate();
    var location = useLocation();
    var _c = useState(null), selectedItem = _c[0], setSelectedItem = _c[1];
    var _d = useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var _e = useState(0), drawerHeight = _e[0], setDrawerHeight = _e[1];
    var refDrawer = useRef(null);
    useEffect(function () {
        if (!item.children)
            return;
        setDrawerHeight(refDrawer.current.clientHeight);
        if (item.children.some(function (child) { return location.pathname.includes(child.path); })) {
            setSelectedItem(item.id);
        }
    }, [location, item]);
    var handleChangeStateCollapse = function (event) {
        if (isOpenDrawer) {
            setSelectedItem(function (prev) { return (!!prev ? null : item.id); });
        }
        else {
            setAnchorEl(event.currentTarget);
        }
    };
    var handleSwitchRoute = function (path) {
        if (path) {
            navigate(path);
        }
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'simple-popover' : undefined;
    if (item.children && item.children.length > 0) {
        return (_jsxs(DrawerCollapseChildrenStyled, { id: id, orientation: 'vertical', in: !!selectedItem, collapsedSize: drawerHeight, children: [_jsxs(MenuItemListSideBar, { className: clsx({
                        active: item.children.some(function (child) { return location.pathname.includes(child.path); })
                    }), ref: refDrawer, onClick: handleChangeStateCollapse, children: [_jsx("div", { className: 'icon', children: item.icon }), isOpenDrawer && (_jsxs(_Fragment, { children: [_jsx(Typography, { children: item.text }), _jsx("div", { className: "".concat(!!selectedItem ? 'open' : 'close'), children: _jsx(CollapseOpenIcon, {}) })] }))] }), isOpenDrawer ? (_jsx(DrawerCollapseChildrenContentStyled, { children: item.children.map(function (child, index) { return (_jsx(BaseDrawerChild, { item: child, isChild: true, isOpenDrawer: isOpenDrawer }, "".concat(child.text, "_").concat(index))); }) })) : (_jsx(PopupDrawer, { title: item.text, anchorEl: anchorEl, open: open, onClose: handleClose, listItems: item.children }))] }));
    }
    return (_jsx(Tooltip, { title: item.text, placement: 'right', disableHoverListener: isOpenDrawer, children: _jsxs(MenuItemListSideBar, { className: clsx((_b = {
                    active: !isChild && item.path !== '/' ? location.pathname.includes(item.path) : item.path === location.pathname
                },
                _b['active-child'] = isChild && location.pathname.includes(item.path),
                _b)), onClick: function () { return handleSwitchRoute(item === null || item === void 0 ? void 0 : item.path); }, children: [_jsx("div", { className: 'icon', children: item.icon }), isOpenDrawer && (_jsx(_Fragment, { children: _jsx(Typography, { children: item.text }) }))] }) }));
};
var BaseDrawerDesktop = function (_a) {
    var listItems = _a.listItems, switchIcon = _a.switchIcon;
    var navigate = useNavigate();
    var _b = useState(true), isOpenDrawer = _b[0], setIsOpenDrawer = _b[1];
    var handleToggleDrawer = function () {
        setIsOpenDrawer(function (prev) { return !prev; });
    };
    var handleGoHome = function () {
        navigate('/');
    };
    return (_jsxs(DrawerStyled, { className: 'lg:block hidden', children: [_jsx(DrawerSwitchButtonStyled, { onClick: handleToggleDrawer, children: switchIcon || _jsx(MenuIcon, { width: 20, height: 20 }) }), _jsxs(DrawerCollapseStyled, { orientation: 'horizontal', in: isOpenDrawer, collapsedSize: iconWidth, children: [_jsx(LogoWrapperStyled, { onClick: handleGoHome, children: _jsx("img", { src: Logo, alt: 'Smart CFO Logo', style: {
                                width: isOpenDrawer ? '90%' : 40,
                                height: !isOpenDrawer ? 'auto' : '137px',
                                margin: '0 8px',
                                transition: 'width 0.2s'
                            } }) }), _jsx(DrawerContentStyled, { isOpenDrawer: isOpenDrawer, children: listItems.map(function (item, index) { return (_jsx(BaseDrawerChild, { isOpenDrawer: isOpenDrawer, item: item }, "".concat(item.text, "_").concat(item.id, "_").concat(index))); }) })] })] }));
};
export default BaseDrawerDesktop;
